import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

import { ROLE_META, ROLE_ORDER } from "../utils/modulesSettingsUtils";

export default function ModulesFiltersCard({
  filters,
  setFilter,
  resetFilters,
  filteredCount,
  totalCount,
  loading,
}) {
  const hasFilters =
    filters.query.trim() ||
    filters.roleId !== "all" ||
    filters.status !== "all";

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-4 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Filtres
            </p>

            <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaFilter className="text-indigo-600 dark:text-indigo-300" />
              Recherche des modules
            </h3>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Recherchez un module par nom, clé technique ou description, puis
              filtrez par rôle.
            </p>
          </div>

          {hasFilters ? (
            <button
              type="button"
              onClick={resetFilters}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaTimes />
              Réinitialiser
            </button>
          ) : null}
        </div>

        <div className="grid gap-3 xl:grid-cols-[1fr,220px,220px]">
          <div className="relative">
            <input
              type="text"
              value={filters.query}
              onChange={(event) => setFilter("query", event.target.value)}
              placeholder="Rechercher un module..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2.5 pl-10 pr-3 text-sm font-medium text-slate-700 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
            />

            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          </div>

          <select
            value={filters.roleId}
            onChange={(event) => setFilter("roleId", event.target.value)}
            className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
          >
            <option value="all">Tous les rôles</option>
            {ROLE_ORDER.map((roleId) => (
              <option key={roleId} value={roleId}>
                {ROLE_META[roleId].label}
              </option>
            ))}
          </select>

          <select
            value={filters.status}
            onChange={(event) => setFilter("status", event.target.value)}
            className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
          >
            <option value="all">Tous les statuts</option>
            <option value="enabled">Activés</option>
            <option value="disabled">Masqués</option>
          </select>
        </div>

        <div className="mt-4 flex flex-wrap gap-2 text-xs text-slate-600 dark:text-slate-300">
          <span className="rounded-full bg-slate-100 px-3 py-1 font-bold dark:bg-slate-800">
            {loading ? "…" : filteredCount} / {totalCount} module(s)
          </span>

          {hasFilters ? (
            <span className="rounded-full bg-indigo-50 px-3 py-1 font-bold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
              Filtres actifs
            </span>
          ) : (
            <span className="rounded-full bg-slate-100 px-3 py-1 font-bold dark:bg-slate-800">
              Aucun filtre
            </span>
          )}
        </div>
      </div>
    </section>
  );
}